import React from 'react';

var SvgContractFilledIcon = function SvgContractFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 3a2 2 0 0 0-2 2v3.75c0 .414.336.75.75.75h2v4.36a1.875 1.875 0 0 0 3.75 0v-.606c0-.416.338-.754.754-.754h5.246v-7.5a2 2 0 0 0-2-2h-8.5Zm13.25 10.75h-7.5v.11a3.125 3.125 0 0 1-3.002 3.122 1.842 1.842 0 0 1-.248.018h8.55a2.2 2.2 0 0 0 2.2-2.2v-1.05Zm-13.252-9.25a.5.5 0 0 0-.498.5v3h1v-3a.5.5 0 0 0-.5-.5h-.002Zm4.002 1.5a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Zm-.75 3.75a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75Z"
  }));
};
SvgContractFilledIcon.displayName = "ContractFilledIcon";

export { SvgContractFilledIcon as S };
